/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  BillingInterval,
  BillingOperationPreviewResponse,
  ChangeRequest,
  DefaultLevel,
  EntityId,
  List,
  PublishedContentSite,
  SearchRecordResult,
  SearchSpaceResult,
  Site,
  SiteAdaptiveContent,
  SiteAdaptiveJSONSchemaWithRegions,
  SiteAdaptiveSchema,
  SiteAdaptiveTemplateCondition,
  SiteBasename,
  SiteFeatureKey,
  SiteProxyOrigin,
  SitePublishOperationPreviewResponse,
  SiteSearchScope,
  SiteSetup,
  SiteStructureItem,
  SiteStructureItemMovePosition,
  SiteStructureItemPointer,
  SiteStyleguideRun,
  SiteTitle,
  SiteType,
  SiteUpgradeReason,
  SiteVisibility,
  Space,
  SubscriptionNotice,
} from "./data-contracts";

/**
 * @description Returns a paginated list of all documentation sites belonging to the organization. Use this to discover available sites before fetching their content, settings, or structure. Members with access only to individual spaces receive the sites that use those spaces as site items, with site administration fields omitted.
 * @tags sites, critical
 * @name ListSites
 * @summary List all documentation sites in an organization
 * @request GET:/orgs/{organizationId}/sites
 * @secure
 */

// @ts-ignore
export const listSites: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Identifier of the space to filter the sites by */
    space?: string;
    /** Filter sites by their title */
    title?: string;
    /** Filter sites by their published status */
    published?: boolean;
    /** Filter by site type */
    type?: SiteType[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Site[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites",
  method: "get",
  streaming: false,
  tags: ["sites", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Creates a new documentation site within the organization. Optionally links one or more existing spaces as content sources at creation time. The site is created in an unpublished state; call the publish endpoint separately to make it publicly accessible.
 * @tags sites
 * @name CreateSite
 * @summary Create a new documentation site in an organization
 * @request POST:/orgs/{organizationId}/sites
 * @secure
 */

// @ts-ignore
export const createSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /**
         * The type of the site. Defaults to:
         *   - Sponsored for community organizations
         *   - Ultimate for all other organizations
         */
        type?: SiteType;
        /** Title of the site */
        title?: SiteTitle;
        /**
         * The visibility setting of the site determines the audience of the site.
         * * `public`: Anyone can access the site, and the site is indexed by search engines.
         * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
         * * `share-link`: Anyone with a secret token in the url can access the site.
         * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
         */
        visibility?: SiteVisibility;
        /** ID of spaces to be added to the site */
        spaces?: string[];
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal
 * @name PreviewSitePublishCheckout
 * @summary Preview checkout information upon publishing a site in the organization.
 * @request GET:/orgs/{organizationId}/sites/publishing/checkout
 * @secure
 */

// @ts-ignore
export const previewSitePublishCheckout: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** The plan of the site to preview the checkout information for. */
    plan: SiteType;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePublishOperationPreviewResponse;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/publishing/checkout",
  method: "get",
  streaming: false,
  tags: ["sites", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves full details for a single documentation site. Use this to inspect a specific site's metadata before reading or modifying its settings, structure, or content. Members with access only through a linked space can retrieve a limited site summary; site administration fields are omitted.
 * @tags sites
 * @name GetSiteById
 * @summary Get a documentation site by its ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const getSiteById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}",
  method: "get",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates a documentation site's configuration. Use this to rename a site, change its access level, or point it at a reverse-proxy path such as https://company.com/docs.
 * @tags sites
 * @name UpdateSiteById
 * @summary Update the properties of a documentation site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const updateSiteById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site */
    title?: SiteTitle;
    /**
     * The visibility setting of the site determines the audience of the site.
     * * `public`: Anyone can access the site, and the site is indexed by search engines.
     * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
     * * `share-link`: Anyone with a secret token in the url can access the site.
     * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
     */
    visibility?: SiteVisibility;
    /** Basename for the site. For e.g. api */
    basename?: SiteBasename;
    adaptiveContent?: SiteAdaptiveContent;
    /** Default level for a piece of content */
    defaultLevel?: DefaultLevel;
    /** ID of the site-space to be used as the default at the root level. If site has sections, this will mark the default site space in the site's default section. */
    defaultSiteSpace?: string;
    /** ID of the site-section to be used as the default. */
    defaultSiteSection?: string;
    /**
     * Configure a proxy URL for a site. For example, you can use it to host the site on a subdirectory of your domain like `https://company.com/docs`.
     * Use `null` to remove the proxy.
     */
    proxy?: SiteProxyOrigin | null;
    /** Attach an existing style guide to the site by the ID of the style guide space, or `null` to detach the current one. The space must be a style guide owned by the same organization. */
    styleguide?: string | null;
  };
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}",
  method: "patch",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name DeleteSiteById
 * @summary Delete a site
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const deleteSiteById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}",
  method: "delete",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the JSON schema that defines the visitor attributes expected by an adaptive content site. Adaptive content uses these attributes (e.g., user role, plan tier) to conditionally show or hide content sections. Use this to understand what visitor data must be provided when rendering adaptive content.
 * @tags sites
 * @name GetSiteAdaptiveSchema
 * @summary Get the visitor attributes JSON schema for an adaptive content site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/adaptive-schema
 * @secure
 */

// @ts-ignore
export const getSiteAdaptiveSchema: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteAdaptiveSchema;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema",
  method: "get",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Replaces the JSON schema that defines expected visitor attributes for adaptive content. The schema controls which attributes (e.g., role, subscription tier) can be used in conditional expressions to show or hide content for specific visitors. After updating, existing conditional expressions are evaluated against the new schema.
 * @tags sites
 * @name UpdateSiteAdaptiveSchema
 * @summary Update the visitor attributes JSON schema for an adaptive content site
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/adaptive-schema
 * @secure
 */

// @ts-ignore
export const updateSiteAdaptiveSchema: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The JSON schema to set on the site. `regions` is only accepted for organizations with regions enabled. */
    jsonSchema: SiteAdaptiveJSONSchemaWithRegions;
  };
  RequestHeaders: {};
  ResponseBody: SiteAdaptiveSchema;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema",
  method: "put",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns pre-generated condition templates derived from the site's visitor attributes schema. These templates can be used as building blocks when writing adaptive content expressions to conditionally show or hide content for different visitor types. Use this to discover available conditions before authoring adaptive rules.
 * @tags sites
 * @name ListSiteAdaptiveTemplateConditions
 * @summary List condition templates for adaptive content expressions in a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/adaptive-schema/template-conditions
 * @secure
 */

// @ts-ignore
export const listSiteAdaptiveTemplateConditions: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: SiteAdaptiveTemplateCondition[];
  };
  ResponseStatusCode: 200;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/adaptive-schema/template-conditions",
  method: "get",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the complete profile needed to render the published experience of a site. Use this when building a site renderer or preview rather than fetching each resource individually.
 * @tags sites
 * @name GetPublishedContentSite
 * @summary Get the full published profile of a site including structure and customization
 * @request GET:/orgs/{organizationId}/sites/{siteId}/published
 * @secure
 */

// @ts-ignore
export const getPublishedContentSite: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {
      "200": { maxAge: "max"; staleWhileRevalidate: "max" };
      "404": { maxAge: "max"; staleWhileRevalidate: "max" };
    };
    edge: {
      mode: "partial";
      data: readonly [
        "getPublishedContentSiteBundle",
        "getPublishedContentPublishedSite",
      ];
      rollout: { edge: 0; shadow: 5 };
    };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: PublishedContentSite;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/published",
  method: "get",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {
      "200": { maxAge: "max", staleWhileRevalidate: "max" },
      "404": { maxAge: "max", staleWhileRevalidate: "max" },
    },
    edge: {
      mode: "partial",
      data: [
        "getPublishedContentSiteBundle",
        "getPublishedContentPublishedSite",
      ],
      rollout: { edge: 0, shadow: 5 },
    },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Makes the site publicly accessible at its configured URL by publishing it. If the organization's plan requires an upgrade, the response includes a Stripe checkout session ID instead of the site object. Use unpublish to take the site offline again.
 * @tags sites
 * @name PublishSite
 * @summary Publish a site to make it publicly accessible
 * @request POST:/orgs/{organizationId}/sites/{siteId}/publish
 * @secure
 */

// @ts-ignore
export const publishSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody:
    | (Site & {
        /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
        subscriptionNotice?: SubscriptionNotice;
      })
    | {
        type: "checkout";
        /** Stripe payment session ID */
        sessionId: string;
        /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
        subscriptionNotice?: SubscriptionNotice;
      };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publish",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Lists the steps to set up a site, from a first edit to publishing, and whether each one is completed. Use it to know what is left to do on a site. Returns no steps once the site has been published.
 * @tags sites
 * @name GetSiteSetup
 * @summary Get the setup steps of a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/setup
 * @secure
 */

// @ts-ignore
export const getSiteSetup: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteSetup;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/setup",
  method: "get",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Removes the site from public access by unpublishing it. The site's configuration and content are preserved; use the publish endpoint to make it accessible again. Use this when you need to temporarily hide a site or take it down for maintenance.
 * @tags sites
 * @name UnpublishSite
 * @summary Take a site offline by unpublishing it
 * @request POST:/orgs/{organizationId}/sites/{siteId}/unpublish
 * @secure
 */

// @ts-ignore
export const unpublishSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/unpublish",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Reorders a site space, section, section group, or external link relative to any sibling at the same structure level. Sorting changes sibling order only; move an item between the root and a group through that item's update operation first.
 * @tags sites
 * @name SortSiteStructure
 * @summary Move a site structure item to a new position
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/structure/sort
 * @secure
 */

// @ts-ignore
export const sortSiteStructure: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Pointer to the site space, section, section group, or external link being moved. */
    item: SiteStructureItemPointer;
    /** The position to move the item to. When not provided the item is moved to the end of the site structure. */
    position: SiteStructureItemMovePosition;
  };
  RequestHeaders: {
    /** Control whether a successful response includes the updated resource representation. */
    prefer?: "return=minimal" | "return=representation";
  };
  ResponseBody: SiteStructureItem | undefined;
  ResponseStatusCode: 200 | 204 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/structure/sort",
  method: "patch",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal
 * @name UpdateSitePlan
 * @summary Update the site plan.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/plan
 * @secure
 */

// @ts-ignore
export const updateSitePlan: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** The app screen URL to bring the user back to after a successful checkout. */
    successReturnURL?: string;
    /** The app screen URL to bring the user back to after a canceled checkout. */
    cancelReturnURL?: string;
  };
  RequestBody: {
    /** The type of the site */
    plan: SiteType;
    /** Desired interval for new subscriptions. Defaults to the existing billing interval. */
    interval?: BillingInterval;
    /** The reason or feature that triggered the site upgrade */
    reason: SiteUpgradeReason;
  };
  RequestHeaders: {};
  ResponseBody:
    | {
        /** User must checkout to complete the update. */
        type: "checkout";
        /** Stripe payment session ID */
        sessionId: string;
      }
    | {
        /** The site plan was successfully updated. */
        type: "success";
        /**
         * * `upgraded`: Subscription was upgraded to include the site
         * * `downgraded`: Subscription was downgraded by removing the site
         * * `no-payment-changes`: No impact on subscription (e.g. trial, unpublished)
         */
        outcome?: "upgraded" | "downgraded" | "no-payment-changes";
      };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/plan",
  method: "post",
  streaming: false,
  tags: ["sites", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal, critical
 * @name PreviewSitePlanUpdate
 * @summary Preview an upgrade to a site plan, returning checkout information.
 * @request GET:/orgs/{organizationId}/sites/{siteId}/plan
 * @secure
 */

// @ts-ignore
export const previewSitePlanUpdate: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** The desired site plan */
    plan: SiteType;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingOperationPreviewResponse;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/plan",
  method: "get",
  streaming: false,
  tags: ["sites", "internal", "critical"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * @description Send a request to ask the organization's admins to upgrade the site's plan.
 * @tags sites, internal
 * @name RequestSiteUpgrade
 * @summary Request site upgrade
 * @request POST:/orgs/{organizationId}/sites/{siteId}/request_upgrade
 * @secure
 */

// @ts-ignore
export const requestSiteUpgrade: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The feature the user is asking a site upgrade for */
    featureKey: SiteFeatureKey;
  };
  RequestHeaders: {};
  ResponseBody: object;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/request_upgrade",
  method: "post",
  streaming: false,
  tags: ["sites", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Performs a full-text search across all published spaces in the site and returns matching pages with relevant excerpts. Use the scope parameter to restrict the search to specific site spaces or sections. Prefer this over the space-level search when you need to search across a multi-section site in one call.
 * @tags sites
 * @name SearchSiteContent
 * @summary Full-text search across all content in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/search
 * @secure
 */

// @ts-ignore
export const searchSiteContent: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: {
    /** @maxLength 512 */
    query: string;
  } & (
    | {
        /** Define the scope of the search. */
        scope: SiteSearchScope;
      }
    | {
        /**
         * Search only in the site spaces provided. Deprecated, use scope instead.
         * @deprecated
         */
        mode?: "specific";
        /** @minLength 1 */
        siteSpaceIds: string[];
      }
    | {
        /**
         * Search in the current site space and all section's defaults. Deprecated, use scope instead.
         * @deprecated
         */
        mode: "current";
        siteSpaceId: string;
      }
    | {
        /**
         * Search in all site-spaces. Deprecated, use scope instead.
         * @deprecated
         */
        mode: "all";
      }
  );
  RequestHeaders: {};
  ResponseBody: List & {
    items: (SearchSpaceResult | SearchRecordResult)[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/search",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Hints the search backend that latency-sensitive site search requests are likely to arrive soon. Call this when a visitor opens the site's search interface.
 * @tags sites
 * @name PrewarmSiteSearch
 * @summary Prewarm a site's search cache
 * @request POST:/orgs/{organizationId}/sites/{siteId}/search/prewarm
 * @secure
 */

// @ts-ignore
export const prewarmSiteSearch: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/search/prewarm",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Populates an empty site with GitBook's default documentation structure, content, and customization. Use this after creating a site without spaces to give it a ready-to-edit starting point.
 * @tags sites
 * @name ApplyTemplateToSite
 * @summary Apply the default documentation template to a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/template
 * @secure
 */

// @ts-ignore
export const applyTemplateToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/template",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Ensures the site has a dedicated style guide space and returns it. The style guide defines writing style and tone guidelines that the AI editor agent references when generating or refining content for the site. If a style guide already exists, this is idempotent and returns the existing space.
 * @tags sites
 * @name CreateSiteStyleguideById
 * @summary Create or retrieve the style guide space for a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/styleguide
 * @secure
 */

// @ts-ignore
export const createSiteStyleguideById: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /** Built-in template id to seed the style guide content with. Omit (or send no body) to create a blank style guide. */
        template?: string;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: Space;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/styleguide",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Starts a style guide check: GitBook Agent reviews the given spaces against the site's style guide and proposes fixes. A space with no check open gets a new draft change request marked as belonging to the returned run; one whose check is still open has it taken over instead, so it stays marked with the run that opened it. Fails if the site has no style guide.
 * @tags sites
 * @name CreateSiteStyleguideRun
 * @summary Start a style guide check run for a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/styleguide/runs
 * @secure
 */

// @ts-ignore
export const createSiteStyleguideRun: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * IDs of the site's spaces to check. Each must be an editable content space of the site, and not the style guide itself.
     * @maxItems 3
     * @minItems 1
     */
    spaces: string[];
  };
  RequestHeaders: {};
  ResponseBody: {
    /** A style guide check run: one time a user asked GitBook Agent to check a set of the site's spaces against the site's style guide, opening a change request for each. */
    run: SiteStyleguideRun;
    /** The change request each space's check runs in: opened by this run, or already open and taken over. One per space that could be started. */
    changeRequests: ChangeRequest[];
  };
  ResponseStatusCode: 201 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/styleguide/runs",
  method: "post",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the site's style guide check runs, most recent first. Use the `styleguideRun` filter on the organization change requests endpoint to get the change requests a run opened.
 * @tags sites
 * @name ListSiteStyleguideRuns
 * @summary List the style guide check runs of a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/styleguide/runs
 * @secure
 */

// @ts-ignore
export const listSiteStyleguideRuns: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteStyleguideRun[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/styleguide/runs",
  method: "get",
  streaming: false,
  tags: ["sites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
